function normalizeUrl(imageUrl, { width = '800', height = '800' } = {}) {
  // Cloudinary options
  const options = ['c_fit', `w_${width}`, `h_${height}`, 'f_auto'].join(',');
  if (!imageUrl) return imageUrl;
  if (imageUrl.includes('/upload/v')) {
    const resizedPhoto = imageUrl.replace(
      /upload\//g,
      `upload/${options}/`
    );
    return resizedPhoto;
  } else {
    return imageUrl;
  }
}

const fallbackToCameraShyImage = (imageElement, errorMesssageImage) => {
  const onImageError = () => {
    imageElement.src = localStorage.getItem('cameraShyImageUrl');
    imageElement.alt = errorMesssageImage;
    imageElement.removeEventListener('error', onImageError);
  };
  imageElement.addEventListener('error', onImageError);
};

/**
 *
 * @param {*} event
 * @param {*} callback
 * @param {*} useSpacebar
 * @returns
 */
function a11yKeyPress(event, callback, useSpacebar) {
  const keyMappings = {
    enter: 13,
    space: 32,
  };

  if (!event || typeof callback !== 'function' || event.type !== 'keypress') return null;
  const code = event.charCode || event.keyCode;
  if (
    (code === keyMappings.enter) ||
    (code === keyMappings.space && useSpacebar)
  ) {
    return callback(event);
  }
  return null;
}

/**
 * 
 * @param {*} resource 
 * @returns {Object}
 */
async function getShopifyResource(resource) {
  const shopifyResponse = await fetch(`${window.Shopify.routes.root}${resource}.json`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return shopifyResponse.json();
}
